export function getDateStr(date, type) {
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	month = month > 9 ? month.toString() : `0${month}`;
	day = day > 9 ? day.toString() : `0${day}`;

	let result = `${year}${month}${day}`;

	if (type === 'comma') {
		result = `${year}.${month}.${day}`;
	}
	if (type === 'hyphen') {
		result = `${year}-${month}-${day}`;
	}

	return result;
}

export function numberWithCommas(nStr) {
	nStr += '';
	let x = nStr.split('.');
	let x1 = x[0];
	let x2 = x.length > 1 ? '.' + x[1] : '';
	let rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

export function formatDate(date, delimiter = '.') {
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	month = month > 9 ? month.toString() : `0${month}`;
	day = day > 9 ? day.toString() : `0${day}`;

	return `${year}${delimiter}${month}${delimiter}${day}`;
}

export function formatTime(date) {
	let hours = date.getHours();
	let minutes = date.getMinutes();

	if (hours > 12) {
		hours = hours - 12;
		return `오후 ${hours}:${minutes}`;
	}

	return `오전 ${hours}:${minutes}`;
}

export function formatDateString(str, delimiter = '.') {
	str = str.replace(/\s/gi, '').replace(/-/g, '').replace(/\//g, '');

	if (str.length === 8) {
		return str.replace(
			/(\d{4})(\d{2})(\d{2})/,
			`$1${delimiter}$2${delimiter}$3`,
		);
	}

	return str;
}

export function formatDatetimeString(str, delimiter = '.') {
	/**
	 * 날짜 + 시간으로 조합 된 문자열은
	 * 날짜에 하이픈 대신 슬래시여야 IE 또는 Safari에서
	 * Date함수를 이용할 때 오류 없이 변환 가능
	 * (ex. 2021-11-23 09:00:00 => 2021/11/23 09:00:00)
	 */
	str = str.replace(/[-|.]/g, '/');
	const dateStr = formatDate(new Date(str), delimiter);
	const timeStr = formatTime(new Date(str));
	return `${dateStr} ${timeStr}`;
}

export function convertHtmlToText(str) {
	return str
		.replace(/(<([^>]+)>)/gi, '')
		.replace(/&lt;/g, '<')
		.replace(/&lt;/g, '<')
		.replace(/&gt/g, '>')
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&nbsp;/g, ' ');
}

export function convertLineBreakToHtml(str) {
	return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

export function diffDateDays(fromDateStr, toDateStr) {
	const fromDate = new Date(fromDateStr);
	const toDate = new Date(toDateStr);
	const calc = toDate.getTime() - fromDate.getTime();

	return calc < 0 ? 0 : parseInt(calc / (24 * 3600 * 1000)) + 1;
}
